import { useEffect } from "react";
import { Form, Input, Select, Row, Col } from "antd";
import secureLocalStorage from "react-secure-storage";
import AddEditForm from "../../../components/molecules/Forms/addEditForm";
import { useDispatch } from "react-redux";
import { submitPermissionsThunk } from "../../../store/thunks/permissionsThunk";

const { Option } = Select;

const AddPermission = ({ editData, statuses, onSuccess, children }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const slsLIUId = secureLocalStorage.getItem("lIUId");

  /*begin::call to api for creating new role*/
  const onSubmit = async (values, editData) => {
    const isEdit = Boolean(editData);
    const currentStatus = editData?.status || null;
    const payload = {
      name: values?.name,
      permissionType: values?.permissionType,
      historySource: "backend",
      historyAction: isEdit ? "update" : "create",
      historyUserID: slsLIUId,
    };

    if (values.status && values.status !== currentStatus) {
      payload.status = values.status;
    }

    if (isEdit) {
      payload.id = editData.key;
    }

    await dispatch(submitPermissionsThunk(payload)).unwrap();
  };

  useEffect(() => {
    if (!editData) return;

    form.setFieldsValue({
      name: editData.name,
      permissionType: editData.permissionType,
      status: editData.status,
    });
  }, [editData]);

  return (
    <AddEditForm
      form={form}
      editData={editData}
      onSubmit={onSubmit}
      onSuccess={onSuccess}
      successMessages={{
        create: "Permission created successfully",
        update: "Permission updated successfully",
      }}
      fields={
        <>
          <Row className="pb-16" gutter={[12, 12]}>
            <Col xs={24} sm={24} md={24} lg={24}>
              <Form.Item
                label="Name"
                name="name"
                rules={[{ required: true, message: "Please enter the name!" }]}
              >
                <Input placeholder="Enter name" className="w-100" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24}>
              <Form.Item
                label="Permission Type"
                name="permissionType"
                rules={[
                  {
                    required: true,
                    message: "Please select permission type!",
                  },
                ]}
              >
                <Select
                  options={[
                    {
                      label: "Basic",
                      value: "Basic",
                    },
                    {
                      label: "Additional",
                      value: "Additional",
                    },
                  ]}
                  placeholder="Select Permission Type"
                />
              </Form.Item>
            </Col>
            {editData && (
              <Col xs={24} sm={24} md={24} lg={24}>
                <Form.Item
                  label="Status"
                  name="status"
                  rules={[
                    { required: true, message: "Please select a status!" },
                  ]}
                >
                  <Select
                    showSearch
                    allowClear
                    options={statuses}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input?.toLowerCase())
                    }
                  />
                </Form.Item>
              </Col>
            )}
          </Row>
        </>
      }
    />
  );
};
export default AddPermission;
